import Carousel from "react-multi-carousel";
import CountdownTimer from "./CountdownTimerComp";
import NavLink from "../../node_modules/react-bootstrap/esm/NavLink";

export default function CompetitionList({ competition }) {
  const responsiveCompetition = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

  return (
    <div className="competition-list pb-2">
      <div className="row gx-3">
        <Carousel
          responsive={responsiveCompetition}
          showDots={true}
          dotListclassName="custom-dot-list-style"
          arrows={false}
          autoPlay={false}
          autoPlaySpeed={3000}
          infinite={true}
        >
          {competition.map((comp) => (
            <div key={comp.id} className="col-lg-12 col-md-12 col-12">
              <NavLink to={`/championship/detail/${comp.id}`}>
                <div className="row competition-image">
                  <div className="col-md-3">
                    <div className="competition-img">
                      <img src="/image/soon.png" alt="competition" />
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="competition-details">
                      <div className="title"> {comp.title}</div>
                      <div className="description">{comp.description}</div>
                      <div className="timer">
                        {" "}
                        <CountdownTimer
                          targetDate={
                            new Date(
                              comp.start_date_time.replace(/T/gi, " ").replace(/.000Z/gi, "")
                            )
                          }
                        />{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
